import { createSelector } from "reselect";
import unionBy from "lodash/unionBy";
import { widgetStateSelector } from "orion-components/AppState/Selectors";
import { defaultCompositeDeviceProfileWidgets } from "../Utils/CompositeDeviceProfileWidgets";

const getWidgetState = (state) => widgetStateSelector(state)?.widgetOrder || [];

export const compositeDeviceWidgetConfig = createSelector([getWidgetState], (widgetState) => {
	const defaultTypes = ["access_control", "map", "files", "cameras"];

	const filteredDefault = defaultCompositeDeviceProfileWidgets?.filter((widget) => defaultTypes?.includes(widget.id));

	const widgetConfig = widgetState.length > 0 ? unionBy(widgetState, filteredDefault, "id") : filteredDefault;

	return widgetConfig;
});
